import { Box, CircularProgress } from "@mui/material";

const MIN_HEIGHT = "18.75rem";

export function LoadingState() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: MIN_HEIGHT,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
